import { Navbar } from "@/components/Navbar";
import { DemoForm } from "@/components/demo/DemoForm";
import { DemoBenefits } from "@/components/demo/DemoBenefits";
import { Footer } from "@/components/Footer";

const Demo = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <div className="max-w-7xl mx-auto px-4 py-20">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-4">
            Get Your Free Demo
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Schedule a personalized demo with our experts and discover how we can help accelerate your business growth with AI-driven strategies.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <DemoBenefits />
          <DemoForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Demo;